import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SecurityFrame } from './CompromisedAccountPage';
import PasswordField from '../../components/accountSecurity/PasswordField';
import { securityRequest, securityError } from '../../services/accountSecurityService';
type Case = {
  id: string;
  account_email: string | null;
  contact_email: string;
  description: string;
  status: string;
  delivery_failed: boolean;
};
export default function AssistedRecoveryAdmin() {
  const [cases, setCases] = useState<Case[]>([]);
  const [selected, setSelected] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [notes, setNotes] = useState('');
  const [verified, setVerified] = useState(false);
  const [step, setStep] = useState('password');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const load = () => securityRequest<Case[]>('assisted/admin', undefined, 'get').then(setCases).catch(e => setError(securityError(e)));
  useEffect(() => {
    load();
  }, []);
  async function action(kind: string) {
    setBusy(true);
    setError('');
    setMessage('');
    try {
      if (kind === 'reauth') {
        await securityRequest('management/start', {
          password
        });
        setStep('code');
        setMessage('Introduce tu código 2FA o uno de respaldo.');
      } else if (kind === 'factor') {
        await securityRequest('management/verify', {
          code
        });
        setCode('');
        setStep('ready');
        setMessage('Identidad administrativa confirmada por cinco minutos.');
      } else {
        const result = await securityRequest('assisted/admin', {
          id: selected,
          decision: kind,
          password,
          notes,
          identity_verified: verified
        });
        setMessage(result.detail);
        setPassword('');
        setNotes('');
        setVerified(false);
        setStep('password');
        await load();
      }
    } catch (e) {
      setError(securityError(e));
    } finally {
      setBusy(false);
    }
  }
  return <SecurityFrame title="Revisión de cuentas comprometidas"><p>Exclusivo para administradores con 2FA activo. Comprueba la identidad por un canal independiente y documenta la revisión. Un correo confirmado no demuestra la titularidad. Otro administrador debe revisar tu propia recuperación.</p><p><Link to="/verificacion-dos-pasos">Configurar verificación en dos pasos</Link></p>
 {error && <div className="security-feedback error" role="alert">{error}</div>}{message && <div className="security-feedback success" role="status">{message}</div>}
 <button className="security-button secondary" disabled={busy} onClick={load}>Actualizar solicitudes</button><div className="security-form"><label className="security-field">Solicitud<select value={selected} onChange={e => {
          setSelected(e.target.value);
          setNotes('');
          setVerified(false);
        }}><option value="">Seleccionar</option>{cases.map(c => <option key={c.id} value={c.id}>{c.account_email || 'Cuenta no identificada'} · {c.status === 'approved' ? 'Autorizada' : 'Pendiente'}</option>)}</select></label>
 {cases.filter(c => c.id === selected).map(c => <div key={c.id} className="security-feedback"><p>Referencia: {c.id}<br />Contacto: {c.contact_email}</p><p>{c.description}</p>{c.delivery_failed && <p>No se pudo confirmar la entrega de una notificación. Revisa SMTP antes de reenviar.</p>}</div>)}
 {selected && <><label className="security-field">Evidencia de revisión<input aria-describedby="recovery-evidence-help" minLength={30} maxLength={1000} value={notes} onChange={e => setNotes(e.target.value)} /></label><p id="recovery-evidence-help">Describe cómo verificaste la identidad (mínimo 30 caracteres).</p><label><input type="checkbox" checked={verified} onChange={e => setVerified(e.target.checked)} /> Comprobé la identidad por un canal independiente.</label><PasswordField label="Contraseña actual" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} />
 {step === 'password' && <button className="security-button" disabled={busy || !password} onClick={() => action('reauth')}>Confirmar identidad administrativa</button>}
 {step === 'code' && <><label className="security-field">Código 2FA o de respaldo<input autoComplete="one-time-code" value={code} onChange={e => setCode(e.target.value)} /></label><button className="security-button" disabled={busy || !code} onClick={() => action('factor')}>Verificar segundo factor</button></>}
 {step === 'ready' && <><button className="security-button" disabled={busy || !verified || notes.length < 30} onClick={() => action(cases.find(c => c.id === selected)?.status === 'approved' ? 'resend' : 'approve')}>Autorizar y enviar enlace</button><button className="security-button secondary" disabled={busy || notes.length < 30} onClick={() => action('reject')}>Rechazar solicitud</button></>}
 </>}</div></SecurityFrame>;
}
